import baseApi, { TAGS } from '../api/baseApi';

/************************************************** API **************************************************/
export const accountsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    archiveAccount: builder.mutation({
      query: (accountId) => ({
        url: `accounts/${accountId}`,
        method: 'DELETE'
      }),
      invalidatesTags: [TAGS.USER_ACCOUNTS]
    }),
    getAccounts: builder.query({
      query: (userId) => ({
        url: 'accounts',
        method: 'GET',
        timeout: 30_000,
        params: { userId }
      }),
      transformResponse: (response) => response.data,
      providesTags: [TAGS.USER_ACCOUNTS]
    })
  })
});

/************************************************** HOOKS **************************************************/
export const { useArchiveAccountMutation, useGetAccountsQuery } = accountsApi;
